import { render } from "./SlideLink.vue?vue&type=template&id=62013d50"
import script from "./SlideLink.vue?vue&type=script&lang=js"
export * from "./SlideLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__